import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { PtCoreActions } from '@pt/pt-core';
import { Store } from '@ngrx/store';
import { NavItem } from '@pt/pt-models';
import { OrganizationsService } from '@pt/api-client';

@Component({
  selector: 'pt-navbar-button-item',
  template: `
    <ng-container *ngIf="item && !item?.children; else BUTTON_DROPDOWN_MENU">
      <ng-container *ngIf="item?.routerLink">
        <button
          type="button"
          class="btn btn-sm w-100 text-start item d-flex gap-1"
          routerLinkActive="btn-link-active"
          [routerLink]="'/' + item.routerLink"
          *ngxPermissionsOnly="item?.permissVisible"
          [routerLinkActiveOptions]="{ exact: false }"
          (click)="$event.preventDefault(); clickItem()"
          [ngClass]="item?.classCss"
          [disabled]="!isEnabled || (item?.disabled | async)"
          [ngbTooltip]="item?.label | async"
          [openDelay]="800"
          [disableTooltip]="!item?.tooltipEnabled"
        >
          <pt-icon
            class="hstack"
            *ngIf="item?.icon"
            [key]="item.icon.key"
            [size]="item.icon.size"
            [iconType]="item.icon.type"
          ></pt-icon>
          <ng-container *ngIf="!item?.tooltipEnabled && item.label">
            <span *ngIf="item.label | async as label">{{ label }}</span>
          </ng-container>
        </button>
      </ng-container>

      <ng-container *ngIf="!item?.routerLink">
        <button
          type="button"
          class="btn btn-sm w-100 text-start item d-flex gap-1"
          *ngxPermissionsOnly="item.permissVisible"
          (click)="clickItem()"
          [ngClass]="item?.classCss"
          [disabled]="!isEnabled || (item?.disabled | async)"
          [ngbTooltip]="item?.label | async"
          [openDelay]="800"
          [disableTooltip]="!item?.tooltipEnabled"
        >
          <pt-icon
            class="hstack"
            *ngIf="item?.icon"
            [key]="item.icon.key"
            [size]="item.icon.size"
            [iconType]="item.icon.type"
          ></pt-icon>
          <ng-container *ngIf="!item?.tooltipEnabled && item.label">
            <span *ngIf="item.label | async as label">{{ label }}</span>
          </ng-container>
        </button>
      </ng-container>
    </ng-container>

    <ng-template #BUTTON_DROPDOWN_MENU>
      <div ngbDropdown display="dynamic">
        <button
          ngbDropdownToggle
          class="btn btn-sm w-100 text-start item d-flex gap-1 align-items-center"
          [id]="item.id"
          [ngClass]="item?.classCss"
          [disabled]="!isEnabled || (item?.disabled | async)"
        >
          <pt-icon
            class="hstack"
            *ngIf="item?.icon"
            [key]="item.icon.key"
            [size]="item.icon.size"
            [iconType]="item.icon.type"
          ></pt-icon>
          <span *ngIf="item.label">{{ item.label | async }}</span>
        </button>

        <ng-container *ngIf="item?.children?.length">
          <div ngbDropdownMenu [attr.aria-labelledby]="item.id">
            <ng-container *ngFor="let childrenItem of item.children">
              <!--              !isChildrenEnable(childrenItem) ||-->
              <button
                ngbDropdownItem
                (click)="clickChildrenItem(childrenItem)"
                *ngIf="childrenItem.type !== 'SEPARATOR'"
                [id]="childrenItem.id"
                [ngClass]="childrenItem.classCss"
                [disabled]="childrenItem.disabled | async"
              >
                <pt-icon
                  *ngIf="childrenItem?.icon"
                  [key]="childrenItem.icon.key"
                  [size]="childrenItem.icon.size"
                  [iconType]="childrenItem.icon.type"
                ></pt-icon>
                {{ childrenItem.label | async }}
              </button>
              <div
                class="dropdown-divider my-0"
                *ngIf="childrenItem.type === 'SEPARATOR'"
              ></div>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-template>
  `,
})
export class NavbarButtonItemComponent implements OnInit {
  @Input() item: NavItem;
  @Output() clickAction = new EventEmitter<NavItem>();

  isEnabled: boolean;

  constructor(
    private orgService: OrganizationsService,
    private permissionService: NgxPermissionsService,
    private store: Store
  ) {}

  ngOnInit(): void {
    if (this.item) {
      this.permissionService
        .hasPermission(this.item.permissEnabled)
        .then((enabled) => {
          this.isEnabled = enabled;
        });
    }
  }

  clickItem() {
    if (this.item?.id === 'DOWNLOAD_MANUAL') {
      this.orgService.downloadManual();
    } else if (this.item?.routerLink) {
      this.store.dispatch(
        PtCoreActions.navigateTo({
          route: [this.item?.routerLink],
          onBlankPage: this.item?.routerLinkOpt?.routerLinkBlank,
          external: this.item?.routerLinkOpt?.routerLinkExternal,
        })
      );
    } else {
      this.clickAction.emit(this.item);
    }
  }

  clickChildrenItem(childrenItem: NavItem) {
    if (childrenItem?.routerLink) {
      this.store.dispatch(
        PtCoreActions.navigateTo({
          route: [childrenItem?.routerLink],
          onBlankPage: childrenItem?.routerLinkOpt?.routerLinkBlank,
          external: childrenItem?.routerLinkOpt?.routerLinkExternal,
        })
      );
    } else {
      this.clickAction.emit(childrenItem);
    }
  }
}
